export default __webpack_public_path__ + "locales/fi/Payments.json?hash=c18b468e442a95508d536b3514852684";